import { and, count, eq, habit, type PowerSyncDrizzleDB } from "@habits/powersync";
import { liveHabitFilters } from "./filters";

/**
 * Counts LIVE habits of user. Feeds `checkUnsyncedActor` (prompt
 * "keep local data?" prompt when migrating from guest to a real account): it used to
 * `count() from(habit)` raw in `auth/controllers.ts`, also counting those in
 * trash (scattered invariant bug). Via live layer it only counts live habits
 * — consistent with rest of views. (Guest→real merge runs unconditionally
 * via `sweepVisitorData`, so no rows are lost; this
 * counter only decides whether prompt is SHOWN.)
 */
export function getLiveHabitCountForUserQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({ total: count() })
    .from(habit)
    .where(and(eq(habit.user_id, userId), ...liveHabitFilters()));
}
